'use client'
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-empty-interface */
/* eslint-disable @typescript-eslint/no-namespace */
var ProviderChain;
(function (ProviderChain) {
    ProviderChain["ECLIPSE"] = "eclipse";
    ProviderChain["EVM"] = "evm";
    ProviderChain["SOLANA"] = "solana";
    ProviderChain["STARKNET"] = "starknet";
})(ProviderChain || (ProviderChain = {}));

export { ProviderChain };
